export default "__VITE_ASSET__b17dbf5c__"